<template>
    <div
        class="board-task"
        :class="{
            'board-task--in-progress': progress > 0 && !completed,
            'board-task--active': isActive,
            'board-task--done': completed,
        }"
    >
        <BonusomatProgress
            :key="progressLoadCounter"
            :progress="progress"
            :always-visible="progressAlwaysVisible"
            :is-completed="completed && progress == 100"
            show-percentage-number
        />
        <DsIcon v-if="repeatable" name="rotate" class="board-task__rotate" />
        <WebpImage v-if="icon && name" :src="icon" :alt="name" css-class="board-task__img" />
        <span class="board-task__title" v-html="title"></span>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import BonusomatProgress from "../shared/bonusomat-progress.vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";

const props = defineProps<{
    name?: string;
    icon?: string;
    repeatable?: boolean;
    completed?: boolean;
    progress?: number;
    isActive?: boolean;
    progressLoadCounter?: string;
    progressAlwaysVisible?: boolean;
}>();

const title = computed(() => props.name?.replace("-", "&#x2011;"));
</script>
